import { render, staticRenderFns } from "./VendorSummaryProperty.vue?vue&type=template&id=20472b86&scoped=true&"
import script from "./VendorSummaryProperty.vue?vue&type=script&lang=js&"
export * from "./VendorSummaryProperty.vue?vue&type=script&lang=js&"
import style0 from "./VendorSummaryProperty.vue?vue&type=style&index=0&id=20472b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20472b86",
  null
  
)

export default component.exports